import { Layout } from "antd";
import ScrollToTop from "components/scroll-to-top";
import { APP_PATH } from "constants/path";
import NotificiationItem from "features/notification/NotificationItem";
import { getMessagingToken } from "firebase-init";
import useResponsive from "hooks/useResponsive";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { selectAuth } from "store/auth/authSlice";
import Breadcrumb from "./Breadcrumb";
import Header from "./Header";
import NavBar from "./NavBar";

const { Content } = Layout;

const DefaultLayout = () => {
	const [collapsed, setCollapsed] = useState(false);
	const { isMobile } = useResponsive();
	const auth = useSelector(selectAuth);

	const location = useLocation();
	const { pathname } = location;

	useEffect(() => {
		if (auth) {
			getMessagingToken();
		}
	}, []);

	useEffect(() => {
		if (isMobile) {
			setCollapsed(true);
		} else {
			setCollapsed(false);
		}
	}, [isMobile]);

	useEffect(() => {
		if (isMobile) {
			setCollapsed(true);
		}
	}, [isMobile, pathname]);

	if (pathname === "/") {
		return <Navigate to={APP_PATH.dashboard} />;
	}

	return (
		<>
			<NotificiationItem />
			{!collapsed && isMobile && (
				<div
					className="fixed w-screen h-screen bg-gray-500 top-0 left-0 z-[20] opacity-50"
					onClick={() => {
						setCollapsed(true);
					}}
				/>
			)}

			<Layout style={{ minHeight: "100vh" }} id="portal">
				<NavBar
					collapsed={collapsed}
					isMobile={isMobile}
					setCollapsed={setCollapsed}
				/>
				<Layout className="overflow-y-auto">
					<Header collapsed={collapsed} isMobile={isMobile} />
					<Content
						style={{
							marginLeft:
								collapsed && !isMobile
									? "80px"
									: !collapsed && !isMobile
									? "280px"
									: "0px",
						}}
						className="transition-all mt-16 p-4 pb-0 mb-20 h-full overflow-hidden"
					>
						<Breadcrumb />

						<Outlet />
					</Content>
					<div
						className="h-20 bg-[#ffffff] flex justify-center items-center"
						style={{
							marginLeft:
								isMobile && collapsed ? "0px" : collapsed ? "80px" : "280px",
						}}
					>
						<span className="opacity-50">Liberty ©2022</span>
					</div>
				</Layout>
			</Layout>
			<ScrollToTop />
		</>
	);
};

export default DefaultLayout;
